import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useHeaderPriorityStore } from "@faire/retailer-visitor-shared/components/HeaderPriorityRenderer/HeaderPriorityPriovider";
import { useCallback, useMemo } from "react";
export var HeaderDropdownType;
(function(HeaderDropdownType) {
    HeaderDropdownType["ACCOUNT"] = "ACCOUNT";
    HeaderDropdownType["NOTIFICATIONS"] = "NOTIFICATIONS";
    HeaderDropdownType["CATEGORIES"] = "CATEGORIES";
    HeaderDropdownType["LANGUAGE_SELECTOR"] = "LANGUAGE_SELECTOR";
})(HeaderDropdownType || (HeaderDropdownType = {}));
export var useIsHeaderDropdownVisible = function() {
    var _useHeaderPriorityStore = _sliced_to_array(useHeaderPriorityStore([
        "isHeaderDropdownVisibleMap"
    ]), 2), isHeaderDropdownVisibleMap = _useHeaderPriorityStore[0].isHeaderDropdownVisibleMap, setHeaderPriorityStore = _useHeaderPriorityStore[1];
    var setHeaderDropdownVisibility = useCallback(function(dropdown, isVisible) {
        setHeaderPriorityStore(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), {
                isHeaderDropdownVisibleMap: _object_spread_props(_object_spread({}, prevState.isHeaderDropdownVisibleMap), _define_property({}, dropdown, isVisible))
            });
        });
    }, [
        setHeaderPriorityStore
    ]);
    var getHeaderDropdownVisibility = useCallback(function(dropdown) {
        return isHeaderDropdownVisibleMap[dropdown];
    }, [
        isHeaderDropdownVisibleMap
    ]);
    var isAnyHeaderDropdownVisible = useMemo(function() {
        return Object.values(isHeaderDropdownVisibleMap).some(function(isVisible) {
            return isVisible;
        });
    }, [
        isHeaderDropdownVisibleMap
    ]);
    return {
        setHeaderDropdownVisibility: setHeaderDropdownVisibility,
        getHeaderDropdownVisibility: getHeaderDropdownVisibility,
        isAnyHeaderDropdownVisible: isAnyHeaderDropdownVisible
    };
};
